(function(){
  var root=document.getElementById('ciVault');if(!root)return;
  var reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  var q=document.getElementById('ciQ'),sug=document.getElementById('ciSug'),deb,lastQ='',ai=-1;
  function closeSug(){sug.hidden=true;sug.innerHTML='';q.setAttribute('aria-expanded','false');ai=-1}
  function money(v){return '£'+Number(v).toFixed(2)}
  function clean(s){return String(s).replace(/[<>&]/g,'')}
  function draw(items,term){
    if(!items.length){sug.innerHTML='<div class="snone">Nothing matching “'+clean(term)+'”. Try a Pokémon name, a set, or a card number.</div>';sug.hidden=false;q.setAttribute('aria-expanded','true');return}
    var h='';
    items.forEach(function(p){
      var u=p.featured_image&&p.featured_image.url?p.featured_image.url:'';
      var img=u?u+(u.indexOf('?')>-1?'&':'?')+'width=80':'';
      h+='<a role="option" href="'+p.url+'">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'<img alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">')+
         '<span class="st">'+clean(p.title)+'</span>'+
         '<span class="sp">'+(p.price?money(p.price):'')+'</span></a>';
    });
    h+='<a class="sall" href="'+rootUrl+'search?type=product&q='+encodeURIComponent(term)+'">See all results for “'+clean(term)+'” →</a>';
    sug.innerHTML=h;sug.hidden=false;q.setAttribute('aria-expanded','true');ai=-1;
  }
  function fetchSug(term){
    fetch(rootUrl+'search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,tag')
      .then(function(r){return r.json()})
      .then(function(d){
        var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        ps=ps.filter(function(p){
          var tg=((p.tags||[]).join(',')).toLowerCase();
          return tg.indexOf('adult')<0&&tg.indexOf('age-gated')<0&&tg.indexOf('login-required')<0;
        });
        if(q.value.trim()===term)draw(ps,term);
      }).catch(function(){closeSug()});
  }
  if(q){
    q.addEventListener('input',function(){
      var v=this.value.trim();clearTimeout(deb);
      if(v.length<2){closeSug();return}
      if(v===lastQ)return;lastQ=v;
      deb=setTimeout(function(){fetchSug(v)},180);
    });
    q.addEventListener('keydown',function(e){
      if(sug.hidden)return;
      var opts=sug.querySelectorAll('a');if(!opts.length)return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault();
        opts.forEach(function(o){o.classList.remove('on')});
        ai=e.key==='ArrowDown'?(ai+1)%opts.length:(ai<=0?opts.length-1:ai-1);
        opts[ai].classList.add('on');opts[ai].scrollIntoView({block:'nearest'});
      } else if(e.key==='Enter'&&ai>-1){e.preventDefault();opts[ai].click()}
      else if(e.key==='Escape'){closeSug();q.blur()}
    });
    document.addEventListener('click',function(e){if(!e.target.closest('.vsearch'))closeSug()});
  }

  var toast;
  function showToast(html){
    if(!toast){toast=document.createElement('div');toast.className='ci-vault-toast';document.body.appendChild(toast)}
    toast.innerHTML=html;toast.classList.add('show');
    clearTimeout(toast._h);toast._h=setTimeout(function(){toast.classList.remove('show')},3600);
  }
  function refreshBubble(){
    fetch(rootUrl+'?sections=cart-icon-bubble').then(function(r){return r.json()}).then(function(d){
      var el=document.getElementById('cart-icon-bubble');
      if(el&&d['cart-icon-bubble']){var t=document.createElement('div');t.innerHTML=d['cart-icon-bubble'];var inner=t.querySelector('#cart-icon-bubble');el.innerHTML=inner?inner.innerHTML:t.innerHTML}
    }).catch(function(){});
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('.vc__add');
    if(!b||b.tagName==='A'||b.disabled)return;
    e.preventDefault();
    var id=b.getAttribute('data-vid'),name=b.getAttribute('data-name')||'Card';
    var lbl=b.querySelector('.vc__add-t'),card=b.closest('.vc');
    b.disabled=true;if(lbl)lbl.textContent='Added';
    fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){
        if(!reduced&&card){
          var img=card.querySelector('img');
          if(img){
            var r0=img.getBoundingClientRect();
            var target=document.getElementById('cart-icon-bubble')||document.querySelector('a[href$="/cart"]');
            var c=target?target.getBoundingClientRect():{left:innerWidth-40,top:14};
            var fly=img.cloneNode();fly.className='ci-vault-flyer';fly.removeAttribute('srcset');fly.removeAttribute('sizes');
            fly.style.left=r0.left+'px';fly.style.top=r0.top+'px';fly.style.width=r0.width+'px';
            document.body.appendChild(fly);
            requestAnimationFrame(function(){fly.style.left=(c.left+6)+'px';fly.style.top=(c.top+2)+'px';fly.style.width='24px';fly.style.opacity='.25';fly.style.transform='rotate(14deg)'});
            setTimeout(function(){fly.remove()},680);
          }
        }
        try{document.dispatchEvent(new CustomEvent('ci:cart'))}catch(x){}
        refreshBubble();
        showToast('<span>✓ '+clean(name).slice(0,52)+' added</span><a href="'+rootUrl+'cart">View basket →</a>');
        setTimeout(function(){b.disabled=false;if(lbl)lbl.textContent='Add'},2200);
      })
      .catch(function(){
        b.disabled=false;if(lbl)lbl.textContent='Add';
        showToast('<span>Couldn’t add that one — open the card page.</span>');
      });
  });
})();
